<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function() {
    var language = document.documentElement.lang;

    function setTranslations(lang) {
        var headingPC = document.querySelector(".slide-heading.slide-pc");
        var headingMobile = document.querySelector(".slide-heading.slide-mobile");
        var textPC = document.querySelector(".slide-text.slide-pc");
        var textMobile = document.querySelector(".slide-text.slide-mobile");
        var button = document.querySelector(".slide-button");

        if (headingPC && headingMobile && textPC && textMobile && button) {
            if (lang === "de") {
                headingPC.textContent = "Zäune und Barrieren";
                headingMobile.textContent = "Zäune und Barrieren";
                textPC.textContent = "2D-, 3D-Zaunpaneele: ein vielseitiger Maschendrahtzaun mit Lieferung nach Luxemburg, Frankreich und Belgien";
                textMobile.textContent = "2D-, 3D-Zaunpaneele: ein vielseitiger Maschendrahtzaun mit Lieferung nach Luxemburg, Frankreich und Belgien";
                button.textContent = "Zaun bestellen";
            } else if (lang === "en") {
                headingPC.textContent = "Fences and Barriers";
                headingMobile.textContent = "Fences and Barriers";
                textPC.textContent = "2D, 3D fence panels: a versatile wire fence with delivery to Luxembourg, France, and Belgium";
                textMobile.textContent = "2D, 3D fence panels: a versatile wire fence with delivery to Luxembourg, France, and Belgium";
                button.textContent = "Order a fence";
            } else if (lang === "fr") {
                headingPC.textContent = "Clôtures et barrières";
                headingMobile.textContent = "Clôtures et barrières";
                textPC.textContent = "Panneaux de clôture 2D, 3D : une clôture grillagée polyvalente avec livraison au Luxembourg, en France et en Belgique";
                textMobile.textContent = "Panneaux de clôture 2D, 3D : une clôture grillagée polyvalente avec livraison au Luxembourg, en France et en Belgique";
                button.textContent = "Commander une clôture";
            }
        }
    }

    setTranslations(language);
});

document.addEventListener('DOMContentLoaded', function () {
  // Получение текущего языка страницы
  const currentLang = document.documentElement.lang;

  // Проверка, что язык страницы совпадает с требуемым
  if (currentLang === "de-LU") {
    // Поиск нужного элемента <label>
    const label = document.querySelector('label[for="basic-customManualPayment-137425781001"] span');

    // Если элемент найден, изменение его текста
    if (label) {
      label.textContent = "Zahlung im Geschäft";
    } else {
      console.warn('Label для указанного селектора не найдено.');
    }
  }
});



document.addEventListener('DOMContentLoaded', () => {
    const header_icons = document.querySelector('.header-icons.header-item')

    if (header_icons)
    {
        const phone_link = document.createElement('a')

        phone_link.setAttribute('href', 'tel:+35220602230')
        phone_link.classList.add('header__icon')
        phone_link.classList.add('header__icon--phone')

        // phone_link.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 512 512"><path fill="#357b3b" d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"/></svg>'
        phone_link.innerHTML = '<span>+352 20 60 22 30</span>'
      
        header_icons.appendChild(phone_link)
    }
})

function applyLanguage(language) {
    localStorage.setItem('languageRedirected', 'true');

    const currentUrl = window.location.href;
    const url = new URL(currentUrl);

    const pathParts = url.pathname.split('/').filter(part => part);

    const validLanguages = ['en', 'de'];
    if (validLanguages.includes(pathParts[0])) {
        pathParts.shift();
    }

    let newPath;
    if (language === 'fr') {
        newPath = `/${pathParts.join('/')}`;
    } else {
        newPath = `/${language}/${pathParts.join('/')}`;
    }

    url.pathname = newPath || '/';
    window.location.href = url.toString();
}

async function detectLanguageAndRedirect() {
    if (localStorage.getItem('languageRedirected')) {
        return;
    }
  
    const response = await fetch('http://ip-api.com/json/');
    const data = await response.json();

    const country = data.countryCode;

    let language = 'fr';

    if (['US', 'GB', 'AU', 'CA'].includes(country)) {
        language = 'en';
    } else if (['DE', 'AT', 'CH'].includes(country)) {
        language = 'de';
    }

    applyLanguage(language);
}

detectLanguageAndRedirect();

document.querySelectorAll('.customer-links').forEach(function(el) {
            if (el.textContent.trim() === 'Se connecter') {
                var svg = `
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="icon icon-account" viewBox="0 0 1024 1024" width="100%" height="100%"><path class="path1" d="M486.4 563.2c-155.275 0-281.6-126.325-281.6-281.6s126.325-281.6 281.6-281.6 281.6 126.325 281.6 281.6-126.325 281.6-281.6 281.6zM486.4 51.2c-127.043 0-230.4 103.357-230.4 230.4s103.357 230.4 230.4 230.4c127.042 0 230.4-103.357 230.4-230.4s-103.358-230.4-230.4-230.4z"></path><path class="path2" d="M896 1024h-819.2c-42.347 0-76.8-34.451-76.8-76.8 0-3.485 0.712-86.285 62.72-168.96 36.094-48.126 85.514-86.36 146.883-113.634 74.957-33.314 168.085-50.206 276.797-50.206 108.71 0 201.838 16.893 276.797 50.206 61.37 27.275 110.789 65.507 146.883 113.634 62.008 82.675 62.72 165.475 62.72 168.96 0 42.349-34.451 76.8-76.8 76.8zM486.4 665.6c-178.52 0-310.267 48.789-381 141.093-53.011 69.174-54.195 139.904-54.2 140.61 0 14.013 11.485 25.498 25.6 25.498h819.2c14.115 0 25.6-11.485 25.6-25.6-0.006-0.603-1.189-71.333-54.198-140.507-70.734-92.304-202.483-141.093-381.002-141.093z"></path></svg>
                `;
                el.innerHTML = svg;
            }
        });

function changeHeaderText() {
            const header = document.querySelector('.template-list-collections .page-header');
            if (header) {
                const lang = document.documentElement.lang;

                const translations = {
                    en: 'Categories',
                    fr: 'Catégories',
                    de: 'Kategorien'
                };

                if (translations[lang]) {
                    header.textContent = translations[lang];
                }
            }
        }

        document.addEventListener('DOMContentLoaded', changeHeaderText);

document.addEventListener('DOMContentLoaded', function() {
    const translations = {
        'en': 'Category',
        'de': 'Kategorie',
        'fr': 'Catégorie'
    };

    let lang = document.documentElement.lang || 'en'; // По умолчанию используем английский

    const breadcrumbSpans = document.querySelectorAll('nav.breadcrumb span');
    if (breadcrumbSpans.length > 1 && translations[lang]) {
        breadcrumbSpans[1].textContent = translations[lang];
    }
});

